<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <companySide
            v-if="type"
            :isButton="isButton"
            @release="gorelease()"
          ></companySide>
          <headSide v-else @release="gorelease()"></headSide>
          <!--列表-->
          <div  class="mt-30">
            <paletteBar
              :paletteObj="paletteObj"
              @onPaletteBar="addMeans()"
            ></paletteBar>
            <div class="mt-30">
              <div
                class="contents fdc"
                v-for="(item, index) in measList"
                :key="index"
              >
                <div class="contents_left fdcc">
                  <div class="garden_box">
                    <span>￥</span><span>{{ item.fileprice }}</span>
                  </div>
                  <p class="mt-10">
                    <span>下载 :</span><span>{{ item.downloadcount }}次</span>
                  </p>
                </div>
                <div class="contents_middle">
                  <p class="contents_middle_title">{{ item.title }}</p>
                  <div class="mecer_font">
                    <p>
                      <span>资料类型 :</span><span>{{ item.categoryStr }}</span>
                    </p>
                    <p>
                      <span class="ml-15">浏览数 :</span
                      ><span>{{ item.visitcount }}</span>
                    </p>
                    <p :class="[item.verify == 1 ? 'red' : '']">
                      <span class="ml-15" >状态 :</span>
                      <span :class="[item.verify ==0 || item.verify == 1 ?'red':'']">{{ item.verify ==0?'审核中':item.verify ==1?'审核不通过':item.verify ==2?'审核通过':'' }}</span>
                    </p>
                  </div>
                </div>
                <div class="contents_right">
                  <p>{{ item.createtime.substring(0, 10) }}</p>
                  <p>
                    <!-- <span
                      :class="[item.verify == 2 ? 'dn' : '']"
                      @click.prevent="onEdit(item)"
                      >编辑资料</span
                    > -->
                    <span @click.prevent="onEdit(item)">编辑资料</span>
                    <span class="ml-12" @click.prevent="onDelete(item)"
                      >删除资料</span
                    >
                    <span class="ml-12" @click="onView(item)">查看详情</span>
                  </p>
                </div>
              </div>
            </div>

            <!--分页-->
            <Pagination
              v-show="total > 0"
              :total="total"
              :page.sync="listQuery.curPage"
              :limit.sync="listQuery.limit"
              @pageChange="pageChange"
            ></Pagination>
          </div>

          <div style="margin-top: 20%">
            <notList :notCode="notCode"></notList>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import {
  getDict,
  addMeans,
  meansList,
  getDetail,
  editMeas,
  delMeas,
  myBrowseList,
} from "@/api/coment";
import { getToken } from "@/utils/auth";
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import headSide from "../../common/headSide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import paletteBar from "../../common/paletteBar";
import contTitle from "../../common/contTitle";
import Pagination from "../../components/Pagination";
import notList from "../../common/notList";
export default {
  components: {
    sidebar,
    headSide,
    companySide,
    commBanner,
    titleHead,
    paletteBar,
    contTitle,
    Pagination,
    notList,
  },
  data() {
    return {
      contTitle: "添加资料",
      headTitle: "我的资料",
      obj: {
        title: "我的资料",
        isShow: false,
        backer: false,
        roleType: "",
        personalType: 9
      },
      paletteObj: {
        paletteTitle: "我发布的资料",
        paletteCount: "",
        isShow: true,
        paletteName: "发布资料",
      },
      measList: [],
      listQuery: {
        curPage: 1,
        limit: 5,
      },
      total: 0, //当前条数
      notCode: false,
      type: false,
      isButton: false
    };
  },
  created() {
    this.getList();
    let type = this.$store.state.user.userInfo.type;
    this.obj.roleType = type;
    if(type == 3){
        this.type = true;
        this.headTitle = "企业资料";
        this.obj.title = "企业资料";
    }
  },
  methods: {
    //发布
    gorelease() {
      this.$router.push("/demand");
    },
    //发布资料
    addMeans() {
      this.$router.push({
        path:'/meansAdd'
      })
    },
    //编辑资料
    onEdit(row) {
      this.$router.push({
        path:'/meansAdd',
        query:{id:row.id}
      });
    },
    //查看详情
    onView(row) {
      this.$router.push({
        path:'/meansDetail',
        query:{id:row.id}
      });
    },
    //删除资料
    onDelete(row) {
      let params = { id: row.id };
      this.$confirm("确定要删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          delMeas(params)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.getList();
                  },
                });
              }
            })
            .catch((err) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //查询列表
    getList() {
      meansList(this.listQuery)
        .then((res) => {
          if (res.code == 0) {
            this.measList = res.page.list;
            this.paletteObj.paletteCount = res.page.totalCount;
            this.total = res.page.totalCount;
			      this.measList.length == 0 ? this.notCode = true : this.notCode = false;
          }
        })
        .catch((err) => {});
    },
    //资料列表分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getList();
    },
  },
};
</script>
<style scoped>
.dn {
  display: none;
}
.red{
  color: #ff7171 !important;
}
.mt-40 {
  margin-top: 40px;
}
.contents {
  width: 100%;
  height: 110px;
  border: 1px solid #dedede;
  margin-bottom: 20px;
  transition: all 0.5s;
}
.contents:hover {
  box-shadow: 0 0 20px #ddd;
}
.contents_left {
  margin-left: 15px;
}
.garden_box {
  width: 62px;
  height: 62px;
  background: #ff7302;
  border: 1px solid #eeeeee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.garden_box span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.garden_box span:nth-child(1) {
  /* margin-left: 11px; */
}
.contents_left p span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.contents_middle {
  text-align: left;
  /* margin-left: 10px; */
  display: flex;
  flex-direction: column;
  width: 58%;
  /* border: 1px solid red; */
}
.contents_middle_title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: break-word;
}
.mecer_font {
  display: flex;
  justify-content: flex-start;
}
.mecer_font p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 15px;
}
/* .contents_middle p:nth-child(2){   
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-top: 15px;
} */
.contents_right {
  text-align: right;
  margin-right: 20px;
}
.contents_right p:nth-child(1) {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.contents_right p:nth-child(2) {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 15px;
}
.contents_right p:nth-child(2):hover {
  cursor: pointer;
}
.contents_right p:nth-child(2) span:hover{
  color: #FF7302;
}
.contents_right p span:last-child {
  color: #343434;
}
.ml-12 {
  margin-left: 12px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.tel {
  text-align: left;
}
.red {
  color: #ff7171;
}

.el-form-item {
  text-align: left;
}
.info_form >>> .el-input__inner {
  height: 50px;
}
.info_form >>> .el-select .el-input__inner {
  height: 50px;
}

.box_textarea >>> .el-textarea__inner {
  /* width: 300px; */
  height: 168px;
}

/deep/.file {
  position: relative;
}
/deep/ .upload-demo {
  position: absolute;
  top: 0;
  right: 0;
}
.busin_btn {
  width: 103px;
  height: 50px;
  background: #e5e5e5;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  border: none;
}
.info_form >>> .refer {
  width: 114px;
  height: 40px;
  background: #3bbb35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-top: 30px;
}
.text_center {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.el-pagination {
  margin-top: 40px;
}
.bater_tetx {
  height: 30px;
  text-align: left;
  margin-left: 15px;
  font-size: 14px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/means.vue